@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

.Paragraph {
  @extend %font-family-primary;

  font-size: $font-size-normal;
  font-weight: $font-weight-normal;
  color: $theme-color-text;
  margin: 0;

  strong {
    color: $theme-color-text;
    font-weight: $font-weight-semibold;
  }

  b {
    color: $theme-color-text;
    font-weight: $font-weight-bold;
  }

  a {
    color: $theme-color-links;
    font-weight: $font-weight-semibold;
    text-decoration: none;

    &:hover {
      color: $theme-color-hover;
      text-decoration: underline;
    }
  }

  small {
    font-size: $font-size-small;
    font-weight: $font-weight-semibold;
    line-height: $line-height-normal;
  }

  ul,
  ol {
    padding-left: 1.5em;
    margin: 0.5em 0;

    li {
      margin-bottom: 0.25em;
    }
  }

  &.text-overflow {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  &.word-break {
    word-break: break-all;
    white-space: pre-wrap;
  }

  &.whitespace-pre-wrap {
    white-space: pre-wrap;
  }

  svg {
    vertical-align: sub;
  }
}
